jQuery(document).ready( function($) {
	$("[data-mobile-menu]")
		.find(".sub-menu")
		.each(function(index, submenu) {
			const $submenu = $(submenu);
			const id = "sub-menu-" + (index + 1);

			$submenu.before(
				`<button type="button" data-toggle="#${id}">
                    <span class="sr-only">Toggle sub menu</span>
                </button>`
			);

			$submenu.prop("id", id);
		});

	$("[data-toggle]").on("click", function() {
		$( this.dataset.toggle ).toggle();
	});

	/*
	* Remove / re-add the mobile search - 20th April 2022 - DI
	* Some of the code below removes the mobile site search and then re-adds it on click
	* I've added this to remediate an accessibility flag in Google Lighthouse which points out that
	* there can't be two IDs named the same on one page, otherwise it screws with screen readers
	* https://web.dev/duplicate-id-aria/
 	*/
	// // Remove the mobile search
	$( ".header__mobile-menu" ).find( ".container" ).remove();

	$( "[data-mobile-menu-toggle]" ).on(
		"click", function() {
			// // Add the class to the body tag
			$( document.documentElement ).toggleClass( "mobile-menu-is-open" );
			// // Add the mobile search
			if ( $( document.documentElement ).hasClass( "mobile-menu-is-open" ) ) {
				$( ".header__mobile-menu" ).find( ".container" ).remove();
				const html = '<div class="container py-4">'
					+ '<form role="search" class="input-group searchform" action="https://eeceradev.wpengine.com">'
						+ '<input type="text" name="s" id="site-search" class="form-control px-2" placeholder="Search...">'
						+ '<label class="sr-only" for="site-search">Search for:</label>'
						+ '<div class="input-group-append">'
							+ '<button type="submit" class="btn">'
								+ '<span class="sr-only">Search</span>'
								+ '<svg class="eecera-icon">'
									+ '<use xlink:href="https://eeceradev.wpengine.com/wp-content/themes/eecera-theme/build/svg/svg.svg#search-solid"></use>'
								+ '</svg>'
							+ '</button>'
						+ '</div>'
					+ '</form>'
				+ '</div>';
				$( ".header__mobile-menu" ).append( html );
			} else {
				// // Remove the mobile search
				$( ".header__mobile-menu" ).find( ".container" ).remove();
			}
		}
	);

	if ($("#wpadminbar").length) {
		$(document.documentElement).addClass("has-admin-bar");
	}

	if ($(".eecera-slider").length) {
		$(".eecera-slider").slick({
			customPaging: function(slick, index) {
				let title = slick.$slides
					.eq(index)
					.find("h2")
					.text();
				let imageSrc = slick.$slides
					.eq(index)
					.find("img")
					.attr("src");

				let pagerMarkup = "<button>" + title;

				if (imageSrc) {
					pagerMarkup += '<img src="' + imageSrc + '"/>';
				}

				pagerMarkup += "</button>";

				return pagerMarkup;
			},
			dots: true,
			arrows: false,
			swipe: false,
			autoplay: true,
			autoplaySpeed: 4000,
			speed: 0
		});
		/*
		* Add alt tags for thumbnail images - 20th April 2022 - DI
		* Alt tags needs to be present in the slider navigation thumbnail images
		* to remediate a Google Lighthouse accessibility flag
		*
		* https://web.dev/image-alt/?utm_source=lighthouse&utm_medium=devtools
		 */
		if ( $( ".slick-dots" ).length ) {
			$( ".slick-dots" ).find( "img" ).attr( "alt", "Slider navigation thumbnail image" );
		}
	}
});
